import {Box, Typography, Stack} from "@mui/material";
import {ProjectWithPreview} from "../ProjectWithPreview";
import {CustomChip} from "../CustomChip";
import {BackButton} from "../BackButton";
import InfoOutlineIcon from "@mui/icons-material/InfoOutline";

const Oncruiter = () => (
    <ProjectWithPreview projectUrl={"https://www.oncruiter.no/"}>
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
            padding: 3,
            height: '100%',
            justifyContent: 'space-between'
        }}>
            <Box sx={{gap: 3, display: 'flex', flexDirection: 'column'}}>
                {/* Project Title */}
                <Box>
                    <Typography variant="h3" sx={{fontWeight: 600, mb: 1}}>
                        oncruiter
                    </Typography>
                    <Typography variant="h6" sx={{color: 'text.secondary'}}>
                        Online recruiter static website
                    </Typography>
                </Box>

                {/* Overview */}
                <Box>
                    <Typography variant="h5" sx={{color: 'secondary.main', mb: 1, fontWeight: 500}}>
                        Overview
                    </Typography>
                    <Typography variant="body1" sx={{lineHeight: 1.7, whiteSpace: 'pre-line'}}>
                        This website was already launched in this design and the cliend hired me to do certain changes.
                        I had 4 tasks on this project:{'\n'}
                        I rebuilt the whole plain javascript app in React, I added a cookie banner, I migrated
                        the host to AWS and installed a SSL certificate.

                    </Typography>
                </Box>

                {/* Tech summary */}
                <Box>
                    <Typography variant="h5" sx={{color: 'secondary.main', mb: 1.5, fontWeight: 500}}>
                        Technologies
                    </Typography>
                    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                        <CustomChip text={'React'} variant={'primary'}/>
                    </Stack>
                </Box>

                {/* Tools summary */}
                <Box>
                    <Typography variant="h5" sx={{color: 'secondary.main', mb: 1.5, fontWeight: 500}}>
                        Tools
                    </Typography>
                    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                        <CustomChip text={'AWS (Amazon Web Services)'} variant={'secondary'}/>
                    </Stack>
                </Box>

                {/*not maintaining disclaimer*/}
                <Typography variant="body1" sx={{
                    lineHeight: 1.7,
                    whiteSpace: 'pre-line',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                }}>
                    <InfoOutlineIcon/>I am not currently maintaining this website.
                </Typography>
            </Box>

            <Box>
                <BackButton/>
            </Box>
        </Box>
    </ProjectWithPreview>
)

export default Oncruiter;